import axios, {AxiosError, AxiosRequestConfig} from "axios";
import { API_URL, ErrorResponse, OPTinsData, UpdateOptResult } from "../constant";
import { LoadOptListResult} from "../constant";
  
export async function LoadOptList(): Promise<LoadOptListResult> {

    try {
        const token = localStorage.getItem("token")
        const data ={}

        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const response = await axios.post(
          `${API_URL}api/opt/loadOPTinsRec`,
          data,
          config
        );
    
        if (response.status === 200)
        {
            console.log(`Load OPT list success, ${response.data.length}`);
            return { success: true, optlist: response.data };
        }
        else if (response.status === 500)
        {
            return { success: false, errorMsg: "Internal Server Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function api_updateOpt(requestdata: OPTinsData): Promise<UpdateOptResult> {
    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };
      
        const response = await axios.post(
          `${API_URL}api/opt/update`,
          requestdata,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, newOpt: response.data };
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" }; 
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function LoadOptBalanceList(licenseNumber: string): Promise<LoadOptListResult> {

    try {
        const token = localStorage.getItem("token")
        const data = { licenseNumber: licenseNumber }
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const response = await axios.post(
          `${API_URL}api/opt/loadOPTinsBalance`,
          data,
          config
        );
    
        if (response.status === 200)
        {
            console.log(`Load OPT balance list success, ${response.data.length}`);
            return { success: true, optlist: response.data };
        }
        else if (response.status === 500)
        {
            return { success: false, errorMsg: "Internal Server Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function api_updateOptNotes(requestdata: OPTinsData): Promise<UpdateOptResult> {
    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };
      
        const response = await axios.post(
          `${API_URL}api/opt/updatenotes`,
          requestdata,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, newOpt: response.data };
        }
        else if (response.status === 400)
        {
            return { success: false, errorMsg: response.data.detail || "Validation Error" }; 
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function api_ReportOpt(): Promise<ErrorResponse> {
    try {
        const token = localStorage.getItem("token");
        const config: AxiosRequestConfig = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: "blob",
        };

        const response = await axios.get(
            `${API_URL}api/opt/reportopt`,
            config
        );

        if (response.status === 200) {
            const disposition = response.headers["content-disposition"];
            let filename = "OPTins_Report.xlsx";

            if (disposition) {
                const matches = disposition.match(/filename="([^"]+)"/);
                if (matches && matches[1]) {
                    filename = matches[1];
                }
            }

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(url);
            return { success: true, errorMsg: "download success" };
        } else {
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}